export const buildStatusSelectStyles = (selectTheme: Record<string, unknown>) => ({
    ...selectTheme,
    valueContainer: (base: Record<string, unknown>) => ({
        ...(typeof selectTheme.valueContainer === 'function'
            ? (selectTheme.valueContainer as (base: never) => Record<string, unknown>)(
                  base as never,
              )
            : base),
        gap: '4px',
    }),
    multiValue: (base: Record<string, unknown>) => ({
        ...base,
        flex: '0 0 auto',
        backgroundColor: 'transparent',
        border: 'none',
        padding: 0,
        margin: 0,
        alignItems: 'center',
    }),
    multiValueLabel: (base: Record<string, unknown>) => ({
        ...base,
        padding: 0,
        backgroundColor: 'transparent',
    }),
    multiValueRemove: (base: Record<string, unknown>) => ({
        ...base,
        color: '#6c757d',
        borderRadius: '4px',
        padding: '0 2px',
        marginLeft: '2px',
        cursor: 'pointer',
        ':hover': {
            backgroundColor: 'rgba(108, 117, 125, 0.15)',
            color: '#343a40',
        },
    }),
});
